import { type CSSObject, type Theme } from '@mui/material';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);

export const DRAWER_WIDTH = 240;

export const openedMixin = (theme: Theme, width?: string | number): CSSObject => ({
    width: width || DRAWER_WIDTH,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

export const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(8)} + 1px)`,
});

export const openedMixinToolbar = (theme: Theme): CSSObject => ({
    ml: `${DRAWER_WIDTH}px`,
    transition: theme.transitions.create('margin-left', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

export const closedMixinToolbar = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('margin-left', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    ml: `calc(${theme.spacing(8)} + 1px)`,
});

export const formatTimeFromString = (timeString: string) => {
    const [hour, minute, second] = timeString.split(':');

    return dayjs().set('hour', parseInt(hour)).set('minute', parseInt(minute)).set('second', parseInt(second)).format('LT');
};
